import Commons from '../../../../Services/Common/Common';

/**
 * SER_BASIC (중대재해처벌법 이행관리 - 평가 목록) 스키마
 */
export const SER_BASIC_Schema = {
  fields: {
    sdCode: { initial: '', label: '평가코드' },
    evaDate: { initial: '', label: '평가일자' },
    evaName: { initial: '', label: '평가자' },
    evaPoint: { initial: 0, label: '취득점수' },
    versionNm: { initial: '', label: '평가표버전' },
    evaStatus: { initial: '', label: '평가상태' },
    completeRate: { initial: 0, label: '진행률' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || context.custCd || ''),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
      EvaDateFrom: (_, context) =>
        Commons.EncryptAES(context.search?.startDate || ''),
      EvaDateTo: (_, context) =>
        Commons.EncryptAES(context.search?.endDate || ''),
      EvaName: (_, context) =>
        Commons.EncryptAES(context.search?.evaName || ''),
      EvaStatus: (_, context) =>
        Commons.EncryptAES(context.search?.evaStatus || ''),
      UserId: (_, context) => context.userInfo?.userid,
    },

    delete1: {
      SdCode: (row) => Commons.EncryptAES(row.sdCode),
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || context.custCd || ''),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
